module.exports = __webpack_public_path__ + "img/gp.bd91dc73.svg";